// @flow
import * as React from 'react';
import { IconButton, Skeleton, Stack, Typography } from '@mui/material';
import { withButton } from '../../../../../features';
import { ClientGroupsEditButton } from './client-groups-form';
import { useClient } from '../../../hooks/client-context';
import { useClientGroupByClientIdQuery } from '../../../../../shared';
import { getUserName } from '@coverright/utils';
import { CreateProfileButton } from '../contact-info-form';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { getRoute } from '../../../../../app/router';
import { StatusDto } from '@coverright/data-access/types/enrollment';

const Groups = () => {
  const client = useClient();
  const {data, loading} = useClientGroupByClientIdQuery({
    variables: {clientId: client?.id},
    skip: !client?.id
  });
  const group = data?.clientGroupByClientId?.clients;


  return (
    <Stack gap={1} flex={1}>
      <Typography variant={'subtitle1'} flex={1}>Client groups</Typography>

      <Stack gap={1} ml={1}>
        {loading && <Stack gap={2}>
          <Skeleton variant={'text'} />
          <Skeleton variant={'text'} />
        </Stack>}

        {group?.map(c => (
          <div key={c.clientId}>
            <Stack gap={1} direction={'row'} alignItems={'center'}>
              <Typography variant={'body2'}>{getUserName(c)}</Typography>
              {c.clientId !== client.id && <IconButton size={'small'} component={Link}
                                                       target={'_blank'}
                                                       to={`/${getRoute('client')}/${c.clientId}`}>
                <ArrowSquareOut size={14} />
              </IconButton>}
            </Stack>
            <Typography variant={'caption'} color={'text.secondary'}>{c.email}</Typography>
          </div>
        ))}

        <CreateProfileButton variant={'outlined'} size={'small'}
                             spouseButton
                             status={client.status}
                             followUpDate={client.followUpDate}
                             sx={{ alignSelf: 'flex-start' }}>Add spouse</CreateProfileButton>
      </Stack>

    </Stack>
  );
};

export const ClientGroups = withButton(
  Groups,
  ClientGroupsEditButton
)
